import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: any = {
  cycle: null,
  isSuccess: false,
  loading: false,
  error: null,
};

export const getPayPeriodByDateReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.GET_PAY_PERIOD_BY_DATE_LOADER:
      return { ...state, loading: true, error: null };

    case laborHoursConstant.GET_PAY_PERIOD_BY_DATE_SUCCESS:
      return {
        ...state,
        cycle: action.payload?.data || null,
        isSuccess: true,
        loading: false,
        error: null,
      };

    case laborHoursConstant.GET_PAY_PERIOD_BY_DATE_FAILURE:
      return { ...state, cycle: null, isSuccess: false, loading: false, error: action.payload };

    case laborHoursConstant.GET_PAY_PERIOD_BY_DATE_RESET:
      return intitialstate;

    default:
      return state;
  }
};
